<template>
    <b-modal
        ref="modalAddDevice"
        title="Add Device"
        title-tag="h2"
        :lazy="true"
        @hide="reset"
    >
        <b-form-group
            label="Manufacturer:"
            label-for="manufacturerLabel"
            label-cols="3"
        >
            <div class="p-2">{{ manufacturerLabel }}</div>
        </b-form-group>

        <b-form-group label="Device:" label-for="deviceCode" label-cols="3">
            <b-form-input
                id="deviceCode"
                name="deviceCode"
                v-model="deviceCode"
                v-validate="'required'"
                :placeholder="deviceCodePlaceholder"
                :class="{ 'border-danger': errors.has('deviceCode') }"
            />
        </b-form-group>

        <b-form-group
            label="Display Name:"
            label-for="devicesName"
            label-cols="3"
            class="col-form-label"
        >
            <b-input
                v-model="displayName"
                placeholder="Display Name (optional)"
            />
        </b-form-group>

        <template #modal-footer>
            <b-button
                class="mr-auto"
                variant="secondary"
                @click="$refs.modalAddDevice.hide()"
                :disabled="isLoading"
            >
                Cancel
            </b-button>
            <loader v-if="isLoading" :margin="1" />
            <b-button
                v-if="!isLoading"
                variant="primary"
                @click="validateAndSave"
            >
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import DevicesListService from "@/services/setting/devices-list.js";
import EXTENSIONS from "@/constants/extensions";

export default {
    name: "ModalAddDevice",
    components: {
        Loader
    },
    data() {
        return {
            manufacturerLabel: "",
            deviceCode: "",
            displayName: "",
            source: "",
            isLoading: false
        };
    },
    computed: {
        deviceCodePlaceholder() {
            if (this.manufacturerLabel === "Stripe Payments") {
                return "Registration Code (required)";
            } else {
                return "Name (required)";
            }
        }
    },
    methods: {
        open(extensionCode) {
            const manufacturerMapping = {
                [EXTENSIONS.CODE.CODE_STRIPE]: "Stripe Payments",
                [EXTENSIONS.CODE.CODE_GRAVITY]: "Gravity Payments"
            };

            this.source = extensionCode;
            this.manufacturerLabel = manufacturerMapping[extensionCode];

            this.$refs.modalAddDevice.show();
        },
        reset() {
            this.deviceCode = "";
            this.displayName = "";
            this.isLoading = false;
            this.$validator.reset();
        },
        async validateAndSave() {
            const valid = await this.$validator.validateAll();
            if (!valid) {
                return;
            }
            this.saveDevice();
        },
        async saveDevice() {
            // mapping of source to required field name
            const requiredFields = {
                [EXTENSIONS.CODE.CODE_STRIPE]: "Registration Code",
                [EXTENSIONS.CODE.CODE_GRAVITY]: "Name"
            };

            const requiredField = requiredFields[this.source];

            // validation: Check if deviceCode is filled
            if (!this.deviceCode.trim()) {
                const fieldName = requiredField;
                this._message(`${fieldName} is required.`, "danger");
                return;
            }

            this.isLoading = true;

            const payload = {
                name: this.deviceCode,
                display_name: this.displayName,
                source: this.source
            };

            try {
                const response = await DevicesListService.saveSettingsAddNewDevice(
                    payload
                );
                console.log("Save device API:", response);

                if (
                    response?.status === 200 &&
                    response?.data?.response?.code === 200
                ) {
                    this._message(response.data.response.message, "success");
                    this.$refs.modalAddDevice.hide();
                    this.$emit("device-added");
                } else {
                    const errorMessage =
                        response?.data?.response?.message ||
                        "Failed to add device.";
                    this._message(errorMessage, "danger");
                }
            } catch (error) {
                console.error("Save device error:", error);
                this._message(error.message, "danger");
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
